
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.373 8a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zm2.625.938h-.49a5.105 5.105 0 01-4.271 0h-.49a3.939 3.939 0 00-3.937 3.937v1.219c0 .776.63 1.406 1.406 1.406H16.53c.776 0 1.406-.63 1.406-1.406v-1.219a3.938 3.938 0 00-3.937-3.938z","fill":"#999"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.272 3.24a.962.962 0 00-.962.963v1.295H1.027a.962.962 0 100 1.924H2.31v1.272a.962.962 0 001.925 0V7.422h1.283a.962.962 0 100-1.924H4.235V4.203a.962.962 0 00-.963-.962z","fill":"#999"}})])
          )
        }
      }
    